import { render, staticRenderFns } from "./PerformanceCustomerDetailActivities.vue?vue&type=template&id=162ec252&scoped=true&"
import script from "./PerformanceCustomerDetailActivities.vue?vue&type=script&lang=ts&"
export * from "./PerformanceCustomerDetailActivities.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceCustomerDetailActivities.vue?vue&type=style&index=0&id=162ec252&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162ec252",
  null
  
)

export default component.exports